/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useCallback } from 'react';
import clsx from 'clsx';
import { useDispatch, useSelector } from "react-redux";
import customStyles from "../../../../../assets/styles/customStyles";
import PrimaryCard from "../../../../Shared/components/Card/PrimaryCard";
import { Row, Col, Image, Space } from "antd";
import { Button, TextField, Box, Typography } from "@mui/material";
import AddIcon from "../../../../../assets/images/icon_actions/Add Icon.svg";
import { NavLink, useParams } from "react-router-dom";
import { PrimaryDrawer } from "../../../../Shared/components/Drawer/PrimaryDrawer";
import MainHeader from "../../../../Shared/components/Header";
import crudActions from "../../../../CRUD/redux/actions";
import ProductIcon from "../../../../../assets/images/icon_menus/ProductIcon.json";
import { ProductUnitConversionsTable } from "./ProductUnitConversionsTable";
import usePrevious from "../../../../Shared/components/Previous";
import actions from "../../redux/actions";
import { toast } from 'react-toastify';
import ExportIcon from "../../../../../assets/images/icon_actions/Export.svg";
import ImportIcon from "../../../../../assets/images/icon_actions/Import.svg";
import { ImportExport } from '../../../../Shared/components/ImportExport';
import DeleteModal from "../../../../Shared/components/DeleteModal";
import { AutoCompleteComponent } from "../../../../Shared/components/AutoCompleteComponent";
import productActions from "../../../Product/redux/actions";
import { checkViewPermission, checkCRUDPermission, checkComponentPermission, idNamingConversion } from '../../../../../helpers/utilities';
import { emptyValidation } from "../../../../../helpers/validation";
import CustomAlert from "../../../../Shared/components/CustomAlert";

const ProductUnitConversions = (props) => {
    const [visible, setVisible] = useState(false);
    const { roleManagement } = useSelector(state => state.authReducer);
    const { createDetails, createError, createLoader, editDetails, editError, getList, getData, editLoader, exportLoader } = useSelector(state => state.crudReducer);
    const { unitMesurementdetails } = useSelector(state => state.productSetupReducer);
    const { myProductdetails } = useSelector(state => state.productProductReducer);
    const [addMore, setAddMore] = useState(false);
    const { history } = props;
    const prevCreateDetails = usePrevious(createDetails);
    const prevCreateError = usePrevious(createError);
    const prevEditDetails = usePrevious(editDetails);
    const prevEditError = usePrevious(editError);
    // const [search, setSearch] = useState('');
    // const prevSearch = usePrevious(search);
    const [skip, setSkip] = useState(0);

    const limit = 25;
    const [sortOrder, setSortOrder] = useState("desc");
    const [sortBy, setSortBy] = useState("id");
    const [loadMore, setLoadMore] = useState(false);
    const [loadMoreContent, setLoadMoreContent] = useState(false);
    const [importVisible, setImportVisible] = useState(false);
    const [conversionId, setConversionId] = useState('');
    const [deleteModal, setDeleteModal] = useState(false);
    const [form, setForm] = useState({});
    const [formRelation, setFormRelation] = useState({});
    const [error, setError] = useState({});
    const [name, setName] = useState('');
    const [view, setView] = useState(false);
    const [filterClassId, setFilterClassId] = useState('');
    const [filterProductId, setFilterProductId] = useState('');

    const { filterParamsClassId } = useParams();

    const handleOpen = () => {
        setConversionId('')
        setVisible(true);
        emptyState();
        emptyStateInput();
    };

    const handleClose = () => {
        setVisible(false);
        emptyState();
        emptyStateInput();

    };
    const emptyState = () => {
        setError({});
    };

    const emptyStateInput = () => {
        setForm({
            "additionalFactor": parseFloat(0.00).toFixed(2),
            "conversionFactor": parseFloat(1.000000).toFixed(6)
        });
        setFormRelation({});
        setView();
    };

    const dispatch = useDispatch();


    const handleUnitClassId = (value) => {
        setFilterClassId(value);
        dispatchFilter(filterProductId, value, sortBy, sortOrder);
    }

    // useEffect(() => {
    //     if ((prevSearch !== undefined && search && search.length > 2 && prevSearch !== search) || (prevSearch !== undefined && search === '' && prevSearch !== search)) {
    //         if (timeoutRef.current !== null) {
    //             clearTimeout(timeoutRef.current);
    //         }
    //         if (search === '') {
    //             dispatchFilter(filterProductId, filterClassId, sortBy, sortOrder);
    //         } else {
    //             timeoutRef.current = setTimeout(() => {
    //                 timeoutRef.current = null;
    //                 dispatchFilter(filterProductId, filterClassId, sortBy, sortOrder);
    //             }, 500);
    //         }
    //     }
    // }, [search]);

    useEffect(() => {
        if (roleManagement !== '' && checkViewPermission('Product Unit Conversions', history, 'Product')) {
            loadTasks();
        }
    }, [roleManagement]);

    useEffect(() => {
        if (myProductdetails !== '') {
            if (filterParamsClassId !== undefined) {
                setFilterClassId(filterParamsClassId);
            }
            dispatchFilter(filterProductId, filterParamsClassId, sortBy, sortOrder);
        }
    }, [myProductdetails]);

    const prevGetData = usePrevious(getData); useEffect(() => {
        if (loadMore && getData === '') {
            setLoadMoreContent(false);
            setLoadMore(true);
        }
        if (prevGetData !== undefined && getData && prevGetData !== getData) {
            const timer = setTimeout(() => {
                if (getData && Array.isArray(getData) && getData.length > 0) {
                    setLoadMore(true);
                    if (getData.length < limit) {
                        setLoadMoreContent(false);
                    } else {
                        setLoadMoreContent(true);
                    }
                } else {
                    setLoadMoreContent(false);
                    setLoadMore(true);
                }
            });

            return () => {
                clearTimeout(timer);
            };
        }
    }, [getData]);

    const dispatchFilter = (filterProductId, filterClassId, sortBy, sortOrder, skip = 0) => {
        if (skip === 0) {
            setLoadMore(false);
            setLoadMoreContent(false);
        }

        let filter = { ["and"]: [] };
        let or = { ["or"]: [] };
        // if (search !== '') {
        //     or['or'].push({ id: { like: '%' + search.trim() + '%' } });
        //     or['or'].push({ description: { like: '%' + search.trim() + '%' } });
        //     or['or'].push({ conversionFactor: { like: '%' + search.trim() + '%' } });
        //     or['or'].push({ additionalFactor: { like: '%' + search.trim() + '%' } });
        // }

        if (filterClassId !== '') {
            let orUnit = { ["or"]: [] };
            orUnit['or'].push({ unitId: filterClassId });
            orUnit['or'].push({ toUnitId: filterClassId });
            filter['and'].push(orUnit);
        }

        if (filterProductId !== '') {
            filter['and'].push({ productId: filterProductId });
        }

        // myProductdetails && myProductdetails?.length > 0 && myProductdetails.map((data) => {
        //     return or['or'].push({ productId: data?.id });
        // });

        filter['and'].push(or);
        setSkip(skip);
        dispatch({
            type: crudActions.GET_DETAILS_START,
            url: 'product-unit-conversions',
            skip: skip,
            filter: {
                where: filter,
                order: sortBy + ' ' + sortOrder,
                limit: limit,
                skip: skip,
            }
        });
    }

    const loadImportExportData = (name, data = 'existing', selected = [], extension = 'xlsx', exportType = 'export') => {
        let filter = { ["and"]: [] };
        let or = { ["or"]: [] };
        if (filterClassId !== '') {
            let orUnit = { ["or"]: [] };
            orUnit['or'].push({ unitId: filterClassId });
            orUnit['or'].push({ toUnitId: filterClassId });
            filter['and'].push(orUnit);
        }

        if (filterProductId !== '') {
            filter['and'].push({ productId: filterProductId });
        }
        filter['and'].push(or);

        dispatch({
            type: crudActions.EXPORT_START,
            export: name,
            data: data,
            selected: selected,
            extension: extension,
            url: 'product-unit-conversions',
            filter: {
                where: !filter.and || filter.and.length === 0 ? {} : filter,
                order: sortBy + ' ' + sortOrder,
            }
        });
    }

    const loadTasks = useCallback(() => {
        dispatch({
            type: productActions.MYPRODUCT_DETAILS_START, url: 'client-products', filter: {
                where: { "and": [{ status: 'ACTIVE' }] },
                order: 'id  desc'
            }
        });
        dispatch({
            type: actions.UNITCLASS_DETAILS_START, url: 'unitclass', filter: {
                order: 'id  desc'
            }
        });
        dispatch({
            type: actions.UNITMESUREMENT_DETAILS_START, url: 'unit', filter: {
                order: 'id  desc'
            }
        });
    });

    const handleSubmit = (e) => {
        e.preventDefault()
        let emptyUnitId = emptyValidation('Unit', form.unitId, 'dropDown');
        let emptyProductId = emptyValidation('Product', form.productId, 'dropDown');
        let emptyToUnitId = emptyValidation('To Unit', form.toUnitId, 'dropDown');
        let emptyConversionFactor = emptyValidation('Conversion Factor', form.conversionFactor);
        emptyState();
        if (emptyProductId.isValid && emptyUnitId.isValid && emptyToUnitId.isValid && emptyConversionFactor.isValid) {
            let data = Object.fromEntries(Object.entries(form).filter(([_, v]) => v != null && v !== ''));
            data['conversionFactor'] = parseFloat(data['conversionFactor']);
            data['additionalFactor'] = parseFloat(data['additionalFactor']);
            dispatch({
                type: conversionId === '' ? crudActions.CREATE_DETAILS_START : crudActions.EDIT_DETAILS_START,
                url: 'product-unit-conversions',
                title: 'Product unit conversions',
                id: conversionId,
                details: data
            });
        } else {
            setError({
                'productId': emptyProductId.errors,
                'unitId': emptyUnitId.errors,
                'toUnitId': emptyToUnitId.errors,
                'conversionFactor': emptyConversionFactor.errors
            })
        }
    }

    const onEdit = (data, view = false) => {
        handleOpen();
        setConversionId(data.id);
        setView(view);
        setForm({
            "productId": data?.productId,
            "unitId": data?.unitId,
            "toUnitId": data?.toUnitId,
            "conversionFactor": data?.conversionFactor,
            "additionalFactor": data?.additionalFactor
        });

        setFormRelation({
            "productName": data?.product?.productName,
            "unit": data?.unit?.name,
            "toUnit": data?.toUnit?.name,
        });
    }

    const handleOpenImport = () => {
        setImportVisible(true);
    }

    const handleImportClose = () => {
        setImportVisible(false);
    }

    useEffect(() => {
        if (prevCreateDetails !== undefined && createDetails && prevCreateDetails !== createDetails) {
            dispatchFilter(filterProductId, filterClassId, sortBy, sortOrder);
            setVisible(false);
            toast.dismiss();
            toast(createDetails);
            emptyStateInput();
            if (addMore) {
                setAddMore(false);
                setTimeout(function () {
                    setVisible(true);
                }, 500)
            }
        } else if (prevCreateError !== undefined && createError && prevCreateError !== createError) {
            let text = createError.error.message;
            if (text.includes("product_id_UNIQUE")) {
                setError({
                    'productId': text
                })
            } else {
                setError({
                    'common': text
                })
            }
        }
    }, [createDetails, createError]);


    useEffect(() => {
        if (prevEditDetails !== undefined && editDetails && prevEditDetails !== editDetails) {
            dispatchFilter(filterProductId, filterClassId, sortBy, sortOrder);
            handleClose();
            toast.dismiss();
            toast(editDetails);
        } else if (prevEditError !== undefined && editError && prevEditError !== editError) {
            let text = editError.error.message;
            if (text.includes("product_id_UNIQUE")) {
                setError({
                    'productId': text
                })
            } else {
                setError({
                    'common': text
                })
            }
        }
    }, [editDetails, editError]);

    const handleAddMore = (e) => {
        handleSubmit(e);
        setAddMore(true);
    }

    const changeHandler = (e, name = '') => {
        if (name !== '') {
            setForm({
                ...form,
                [name]: e,
            });
        } else {
            setForm({
                ...form,
                [e.target.name]: e.target.type === 'number' && e.target.value !== '' ? e.target.value : e.target.value
            });
        }
    }


    const requestSort = (sortBy, sortOrder) => {
        setSortBy(sortBy);
        setSortOrder(sortOrder);
        dispatchFilter(filterProductId, filterClassId, sortBy, sortOrder);
    }

    //const [iconAnimation, setIconAnimation] = useState(false);

    const loadMoreTask = () => {
        let s = skip + limit;
        dispatchFilter(filterProductId, filterClassId, sortBy, sortOrder, s);
    }

    const customObject = (details, id) => {
        let a = details && details.filter(function (el) { return el.id === parseInt(id) });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }

    const onDelete = (data) => {
        setDeleteModal(true);
        setConversionId(data.id);
        setName(data?.unit?.name);
    }

    const classes = customStyles();
    return (
        <React.Fragment>
            <MainHeader {...props} img={ProductIcon} title={'Product'}
                links={[{ 'label': 'Product', 'link': '/product' }, { 'label': 'Product Unit Conversions', 'link': '' }]} />
            <div className={clsx(classes.margin40, classes.listTableMargin)}>
                <PrimaryCard
                    title={'Product Unit Conversions'}
                    component={
                        <>
                            <Row align="middle" className={classes.marginBottom20}>
                                <Col xxl={6} xl={7} lg={8} md={10} sm={13} xs={24}>
                                    {/* {
                                        roleManagement !== '' && checkComponentPermission('Product Unit Conversions', 'Action', 'Search') &&
                                        <div className={clsx(classes.searchAnimation, { [classes.iconAnimation]: iconAnimation })}>
                                            <TextField autoComplete='one-time-code'
                                                placeholder='Search ID, Conversion Factor and Addition Factor'
                                                type='search'
                                                className={classes.comInput}
                                                variant={'standard'}
                                                onChange={(e) => setSearch(e.target.value)}
                                                fullWidth
                                                onFocus={() => setIconAnimation(true)}
                                                onBlur={() => setIconAnimation(false)}
                                            />
                                            <Image
                                                src={SearchIcon}
                                                preview={false}
                                            />
                                        </div>
                                    } */}
                                </Col>
                                <Col xxl={18} xl={17} lg={16} md={14} sm={11} xs={24} className={clsx(classes.textAlignRight, classes.customerLabelNone)}>
                                    <div className={classes.vertiCalScrollOverFlow}>
                                        <Space size={[20, 20]} direction="horizontal" align="center" className={clsx(classes.removeUnderline)}>
                                            {
                                                roleManagement !== '' && checkComponentPermission('Product Unit Conversions', 'Action', 'All Dropdown') &&
                                                <><AutoCompleteComponent
                                                    customLabel={"All Product"}
                                                    heads={[{ 'key': 'productName', 'name': 'Product Name' },
                                                    { 'key': 'productId', 'name': 'Product ID' }]}
                                                    details={myProductdetails}
                                                    parentValue={customObject(myProductdetails, filterProductId)}
                                                    position={"bottom"}
                                                    customClasses={classes.customWidth172P}
                                                    id={idNamingConversion('All Product', 'productUnitConversions', 'DropDown')}
                                                    variant={'outlined'}
                                                    onChangeText={(data) => {
                                                        if (data === '') {
                                                            setFilterProductId('');
                                                            dispatchFilter('', filterClassId, sortBy, sortOrder);
                                                        }
                                                    }}
                                                    onChange={(data) => {
                                                        setFilterProductId(data.id) // help to set the value
                                                        dispatchFilter(data.id, filterClassId, sortBy, sortOrder);
                                                    }}
                                                />

                                                    <AutoCompleteComponent
                                                        customLabel={"All Group"}
                                                        heads={[{ 'key': 'name', 'name': 'Name' }]}
                                                        details={unitMesurementdetails}
                                                        parentValue={customObject(unitMesurementdetails, filterClassId)}
                                                        position={"bottom"}
                                                        variant={'outlined'}
                                                        id={idNamingConversion('All Group', 'productUnitConversions', 'DropDown')}
                                                        customClasses={classes.customWidth172P}

                                                        onChangeText={(data) => {
                                                            if (data === '') {
                                                                handleUnitClassId('')
                                                            }
                                                        }}
                                                        onChange={(data) => {
                                                            handleUnitClassId(data.id)
                                                        }}
                                                    />
                                                </>
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('Product Unit Conversions', 'Action', 'Export') &&
                                                <NavLink
                                                    to={"#"}
                                                    id={idNamingConversion('Export', 'productUnitConversions', 'DropDown')}
                                                    onClick={() => loadImportExportData('Product Unit Conversions')}
                                                    className={clsx(classes.customLink)}>
                                                    <Image
                                                        src={ExportIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage, classes.padding10Left)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Export</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('Product Unit Conversions', 'Action', 'Import') &&
                                                <NavLink
                                                    to={"#"}
                                                    id={idNamingConversion('Import', 'productUnitConversions', 'DropDown')}
                                                    onClick={() => handleOpenImport()}
                                                    className={clsx(classes.customLink)}>
                                                    <Image
                                                        src={ImportIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage, classes.padding10Left)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Import</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkCRUDPermission('Product Unit Conversions', 'create', 'Product') &&
                                                <NavLink
                                                    to={"#"}
                                                    id={idNamingConversion('Add Product Unit Conversion', 'productUnitConversions', 'DropDown')}
                                                    onClick={() => handleOpen()}
                                                    className={clsx(classes.customLink)}>
                                                    <Image
                                                        src={AddIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage, classes.padding10Left)}
                                                    /><span className={clsx(classes.addLink, classes.color, classes.bold)}>Add Product Unit Conversion</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('Product Unit Conversions', 'Action', 'Filter') &&
                                                <></>
                                            }
                                        </Space>
                                    </div>
                                </Col>
                            </Row>
                            <ProductUnitConversionsTable
                                filterProductId={filterProductId}
                                filterClassId={filterClassId}
                                onEdit={(data, view) => onEdit(data, view)}
                                onDelete={(data) => onDelete(data)}
                                details={getList}
                                loadMore={loadMore}
                                roleManagement={roleManagement}
                                loadMoreContent={loadMoreContent}
                                loadMoreTask={() => loadMoreTask()}
                                sortOrder={sortOrder} sortBy={sortBy}
                                onRequestSort={(sortBy, sortOrder) => requestSort(sortBy, sortOrder)} />
                        </>
                    }
                />
            </div>
            <PrimaryDrawer
                anchor={'right'}
                open={visible}
                variant={'temporary'}
                width={'495px'}
                handleClose={() => handleClose()}
                title={`${conversionId ? `${view ? 'View' : 'Edit'}` : 'Add New'} Product Unit Conversion`}
                className={clsx(classes.closeBackGround, classes.width100P)}
                component={
                    <Box
                        className={clsx(classes.customForm, classes.removeUnderline)}
                        component="form"
                        autoComplete='off'
                        onSubmit={(e) => handleSubmit(e)}>
                        <div className={classes.customFormFlex}>
                            <Row gutter={20}>
                                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                    {
                                        view ?
                                            <>
                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Product</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{formRelation?.productName || '---'}</Typography>
                                            </> :
                                            <AutoCompleteComponent
                                                name={["Product ", <span key={'Product'} className={classes.colorRedRequired}> *</span>]}
                                                heads={[{ 'key': 'productName', 'name': 'Name' },
                                                { 'key': 'productId', 'name': 'Product ID' }]}
                                                details={myProductdetails}
                                                parentValue={customObject(myProductdetails, form.productId)}
                                                onChange={(data) => changeHandler(data.id, 'productId')}
                                                position={"bottom"}
                                                id={idNamingConversion('Product', 'productUnitConversions', 'DropDown')}
                                                parentError={error.productId}
                                            />
                                    }
                                </Col>
                                <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24} className={classes.positionRelative}>
                                    <div className={classes.unitFor}>For 1</div>
                                    <div className={classes.unitForText}>
                                        {
                                            view ?
                                                <>
                                                    <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>From Unit</Typography>
                                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{formRelation.unit}</Typography>
                                                </> :
                                                <AutoCompleteComponent
                                                    name={["From Unit ", <span key={'From Unit'} className={classes.colorRedRequired}> *</span>]}
                                                    heads={[{ 'key': 'name', 'name': 'Unit' },
                                                    { 'key': 'description', 'name': 'Description' }]}
                                                    details={unitMesurementdetails}
                                                    id={idNamingConversion('From Unit', 'productUnitConversions', 'DropDown')}
                                                    parentValue={customObject(unitMesurementdetails, form.unitId)}
                                                    onChange={(data) => changeHandler(data.id, 'unitId')}
                                                    position={"bottom"}
                                                    customClasses={classes.margin20t}
                                                    parentError={error.unitId}
                                                />
                                        }
                                    </div>
                                </Col>
                                <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                    {
                                        view ?
                                            <>
                                                <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Conversion  Factor</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form.conversionFactor}</Typography>
                                            </> :
                                            <TextField autoComplete='one-time-code'
                                                label='Conversion  Factor'
                                                variant={'standard'}
                                                type={'number'}
                                                className={clsx(classes.margin20t)}
                                                error={error.conversionFactor ? true : false}
                                                helperText={error.conversionFactor}
                                                name={"conversionFactor"}
                                                id={idNamingConversion('Conversion  Factor', 'productUnitConversions', 'TextField')}
                                                fullWidth
                                                onWheel={(e) => e.target.blur()}
                                                value={form.conversionFactor ? form.conversionFactor : ''}
                                                InputProps={{
                                                    classes: {
                                                        input: classes.textFieldColor,
                                                    },
                                                    step: "any"
                                                }}
                                                InputLabelProps={{
                                                    className: classes.textFieldLableColorCustom,
                                                }}
                                                onChange={(e) => changeHandler(e)}
                                            />
                                    }
                                </Col>
                                <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                    {
                                        view ?
                                            <>
                                                <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>To Unit</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{formRelation.toUnit}</Typography>
                                            </> :
                                            <AutoCompleteComponent
                                                name={["To Unit ", <span key={'To Unit'} className={classes.colorRedRequired}> *</span>]}
                                                heads={[{ 'key': 'name', 'name': 'Unit' },
                                                { 'key': 'description', 'name': 'Description' }]}
                                                details={unitMesurementdetails}
                                                id={idNamingConversion('To Unit', 'productUnitConversions', 'DropDown')}
                                                parentValue={customObject(unitMesurementdetails, form.toUnitId)}
                                                onChange={(data) => changeHandler(data.id, 'toUnitId')}
                                                position={"bottom"}
                                                customClasses={classes.margin20t}
                                                parentError={error.toUnitId}
                                            />
                                    }
                                </Col>
                                <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                    {
                                        view ?
                                            <>
                                                <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Addition Factor</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form.additionalFactor}</Typography>
                                            </> :
                                            <TextField autoComplete='one-time-code'
                                                label='Addition Factor'
                                                variant={'standard'}
                                                type={'number'}
                                                className={clsx(classes.margin20t)}
                                                name={"additionalFactor"}
                                                fullWidth
                                                id={idNamingConversion('Addition Factor', 'productUnitConversions', 'TextField')}
                                                onWheel={(e) => e.target.blur()}
                                                value={form.additionalFactor ? form.additionalFactor : ''}
                                                InputProps={{
                                                    classes: {
                                                        input: classes.textFieldColor,
                                                    },
                                                    step: "any"
                                                }}
                                                InputLabelProps={{
                                                    className: classes.textFieldLableColorCustom,
                                                }}
                                                onChange={(e) => changeHandler(e)}
                                            />
                                    }
                                </Col>
                                {
                                    form.unitId && form.toUnitId && form.conversionFactor &&
                                    <Col span={24}>
                                        <Typography variant={'subtitle1'} className={clsx(classes.addressSmall, classes.bold, classes.margin20t, classes.fonSize13)}>Note:</Typography>
                                        <div className={clsx(classes.unitNote, classes.bold)}>
                                            {`1 ${customObject(unitMesurementdetails, parseInt(form.unitId))?.name} = ${(parseFloat(form.conversionFactor) + parseFloat(form.additionalFactor))} ${customObject(unitMesurementdetails, parseInt(form.toUnitId))?.name}`}
                                        </div>
                                    </Col>
                                }
                                {
                                    error?.common && <Col span={24}><CustomAlert error={error?.common} customClass={clsx(classes.uploadError, classes.margin10t)} /></Col>
                                }
                            </Row>
                        </div>
                        <div className={clsx(classes.btnParent)}>

                            <Space direction="horizontal" align="center" size={[10, 10]}>
                                {
                                    !view ? <>
                                        <Button
                                            key="save"
                                            type='submit'
                                            color='primary'
                                            variant="contained"
                                            id={idNamingConversion('Save', 'productUnitConversions', 'Button')}
                                            className={clsx(classes.modalBtn, { [classes.loading]: createLoader || editLoader })}>
                                            {
                                                conversionId ? 'Update & Close' : 'Save & Close'
                                            }
                                        </Button>
                                        {
                                            !conversionId &&
                                            <Button
                                                key="add"
                                                color='primary'
                                                variant="contained"
                                                id={idNamingConversion('Add More', 'productUnitConversions', 'Button')}
                                                className={clsx(classes.AddMoreBtn, { [classes.loading]: createLoader || editLoader })}
                                                onClick={(e) => handleAddMore(e)}>
                                                Add More
                                            </Button>
                                        }</> : <NavLink to={'#'} className={clsx(classes.modalBtn)} onClick={() => setView(false)}>Edit</NavLink>
                                }
                            </Space>

                        </div>
                    </Box>
                }
            />
            <DeleteModal onClose={(v) => { setDeleteModal(false) }}
                id={conversionId}
                loadTasks={() => dispatchFilter(filterProductId, filterClassId, sortBy, sortOrder)}
                name={name} url={'product-unit-conversions'}
                title={'Product Unit Conversions'}
                visible={deleteModal} />
            <ImportExport
                handleClose={() => handleImportClose()}
                visible={importVisible}
                title={'Product Unit Conversions'}
                type={'import'}
                loader={exportLoader}
                loadImportExportData={(name, type, selected, extension) => loadImportExportData(name, type, selected, extension)}
                details={[]}
                loadTasks={() => dispatchFilter(filterProductId, filterClassId, sortBy, sortOrder)}
            />

        </React.Fragment>
    )
}
export default ProductUnitConversions